export default "__VITE_ASSET__4ffbbeab__"